// extracted by mini-css-extract-plugin
export var body = "_27-8";
export var button = "_27-0";
export var closeButton = "_27-5";
export var content = "_27-3";
export var empty = "_27-f";
export var grid = "_27-c";
export var header = "_27-4";
export var icon = "_27-1";
export var option = "_27-d";
export var optionSelected = "_27-e";
export var overlay = "_27-2";
export var searchIcon = "_27-a";
export var searchInput = "_27-b";
export var searchWrapper = "_27-9";
export var title = "_27-6";
export var visuallyHidden = "_27-7";